import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Divider,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Accordian({ data, marginLeft, maxH="auto", fontSize="16px", paddingRight, pt, pb }) {
  // Determine settings based on screen size
  const allowMultiple = useBreakpointValue({ base: true, md: true });
  const defaultIndex = useBreakpointValue({ 
    base: data?.[0]?.component ? [0] : [], 
    md: data?.[0]?.component ? [0] : [] 
  });
  
  const navigate=useNavigate();
  return (
    <>
      <Accordion className="mt-0" paddingRight={paddingRight} defaultIndex={defaultIndex} allowMultiple={allowMultiple}>
        {data?.length > 0 &&
          data?.map((item, index) => (
            <AccordionItem border={"none"} key={index}>
              <AccordionButton pt={pt} pb={pb} className="px-0" onClick={()=>item?.link && navigate(`${item?.link}`)} >
                <Box flex="1" textAlign="left">
                  <Text
                    fontSize={fontSize}
                    fontWeight={"700"}
                    lineHeight={"24px"}
                    color={"color.primary"}
                  >
                    {item?.name}
                  </Text>
                </Box>
                <AccordionIcon width={{base:"26",md:"32px"}} height={{base:"26",md:"32px"}} />
              </AccordionButton>
              <Divider color={"color.lightgray7"} borderBottomWidth={"0.1px"} />
              <Box>
                <AccordionPanel className="accordian-filter-body-scrollbar px-0" py={2} maxH={maxH} overflowY={maxH !== "auto" ? "auto" : "hidden"}>
                  {item?.component}
                </AccordionPanel>
              </Box>
            </AccordionItem>
          ))}
      </Accordion>
    </>
  );
}
